import { Injectable } from '@angular/core';

import { RepositoryService } from '@_services/api/repository.service';
import { GeneratedStratalotPriceListApiService } from './stratalot-price-list-api-generated.service';

@Injectable({
  providedIn: 'root'
})
export class StratalotPriceListApiService extends GeneratedStratalotPriceListApiService {
  constructor(repo: RepositoryService) {
    super(repo);
  }
}
